import React from 'react';
import TextInfo, {
  TEXT_COLOR,
  TEXT_DISPLAY,
  TEXT_SIZE,
} from '@/bit/components/components.text';
import Button, {
  BUTTON_TYPE,
  BUTTON_FONT_FAMILY,
  BUTTON_HEIGHT,
  BUTTON_WIDTH,
} from '@/bit/components/components.button';

const LoginCard = ({ className, text, label, onClick }) => {
  return (
    <div className={`${className} login-card`}>
      <TextInfo
        text={text}
        size={TEXT_SIZE.TITLE6}
        color={TEXT_COLOR.WHITE}
        display={TEXT_DISPLAY.BLOCK}
      />
      <Button
        onClick={onClick}
        label={label}
        className=""
        type={BUTTON_TYPE.SECONDARY}
        height={BUTTON_HEIGHT.SMALL}
        width={BUTTON_WIDTH.DEFAULT}
        taggingInfo={{
          componentName: 'button',
          componentVariation: 'all',
          componentContent: label,
          componentProduct: '',
        }}
        cyData="loginCard__button"
      />
      <style jsx>
        {`
          @import '../../styles/colors.scss';
          .login-card {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: $color-gp--blue_dark;
            padding: 20px 16px;
            border-radius: 8px;
          }
        `}
      </style>
    </div>
  );
};

export default LoginCard;
